import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { get } from 'lodash';

import { formatCurrency } from 'utils/formatCurrency';

import styles from './styles.module.scss';

const AutopayScheduled = () => {
  const quickpayData = useSelector((state) => state.quickpay.data);
  const scheduledAutopay = useSelector((state) => state.quickpay.scheduledAutopay);
  const allPaymentMethods = (quickpayData?.paymentAccounts || []).map((acc) => ({
    value: acc.accountId,
    title: `${(acc.accountType)} ${acc.category === 'bankcard' ? `xxxx-xxxx-xxxx-${acc.cardNumberLast4}` : `xxxx${acc.accountNumberLast4}`}`,
  }));

  const frequency = moment(new Date(get(quickpayData, 'suggestedAutopayNextApplyDate', ''))).format('Do');
  const nextDate = get(quickpayData, 'suggestedAutopayNextApplyDate') ? moment(new Date(get(quickpayData, 'suggestedAutopayNextApplyDate'))).format('MM/DD/YYYY').toString() : '-';

  const renderFromAccount = () => {
    const scheduledPaymentAccountId = scheduledAutopay?.paymentAccountId;
    if (!scheduledPaymentAccountId) return '-';
    const selectedMethod = allPaymentMethods.find((acc) => acc.value === scheduledPaymentAccountId);
    return selectedMethod?.title;
  };

  return (
    <div className={`${styles.quickpay} ${styles.autopayScheduled}`}>
      <div className={styles.content}>
        <h1>Autopay was scheduled successfully!</h1>
        <div className={styles.paymentInfo}>
          <table>
            <tbody>
              <tr>
                <td>Frequency</td>
                <td>
                  Monthly (Every
                  {' '}
                  {frequency}
                  )
                </td>
              </tr>
              <tr>
                <td>Next Date</td>
                <td>{nextDate}</td>
              </tr>
              <tr>
                <td>Payment Amount</td>
                <td>
                  $
                  {get(quickpayData, 'suggestedAutopayAmount') ? formatCurrency(get(quickpayData, 'suggestedAutopayAmount'), 2) : '-'}
                </td>
              </tr>
              <tr>
                <td>Pay From Account</td>
                <td className={styles.paymentCell}>{renderFromAccount()}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={styles.stickyFooter}>
        <h2 className="mb-4 text-center d-block text-uppercase">
          You&apos;re all set
        </h2>
        <p className="text-center d-block mb-4">
          For your security, please close this
          <br />
          browser session
        </p>
      </div>
    </div>
  );
};

AutopayScheduled.propTypes = {};

export default withRouter(AutopayScheduled);
